import './Activities.css';
import React from 'react';
import GlobalProps from '../globalProps';
import { t } from '../../locales/translate';
import { Activities } from './Activities';
import { ProductInGroup } from '../../model/product';

interface Props extends GlobalProps {
  activitiesComponentClassName?: string;
  products: Array<ProductInGroup>;
  onProductLinkClick?: (sku?: string) => void;
}

export function ProductImportantActivities({
  id,
  className,
  style,
  activitiesComponentClassName,
  products,
  onProductLinkClick,
}: Props): JSX.Element | null {
  return (
    <div id={id} className={className} style={style}>
      {products.map(
        (product) =>
          product.id && (
            <Activities
              key={product.id}
              className={activitiesComponentClassName}
              subjectType={product.__typename === 'Event' ? 'event' : 'merch_product'}
              subjectId={product.id}
              title={
                <>
                  <span>{t.model.order.importantInformationAboutProducts}</span>
                  <a className="link link--classic" onClick={() => onProductLinkClick?.(product.sku)}>
                    {product.sku || product.id}
                  </a>
                </>
              }
              metaFilter="productImportant"
              collapseWhenLoading
              collapseWhenEmpty
              readOnly
            />
          )
      )}
    </div>
  );
}
